import {
  CarState,
  CarCondition,
  CarDrive,
} from './constants';
import typeHints from './typeHints';

const attributes = {
  c_brand: {
    friendly: 'Brand',
    validations: {
      maxLength: 45,
    },
  },
  c_year: {
    friendly: 'Year',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  c_model: {
    friendly: 'Model',
    validations: {
      maxLength: 100,
    },
  },
  c_sub_model: {
    friendly: 'Sub Model',
    validations: {
      maxLength: 45,
    },
  },
  c_body_style: {
    friendly: 'Body Style',
    validations: {
      maxLength: 45,
    },
  },
  c_origin_country: {
    friendly: 'Origin Country',
    validations: {
      maxLength: 45,
    },
  },
  c_series_production: {
    friendly: 'Series Production',
    validations: {
      maxLength: 45,
    },
  },
  c_production_figures: {
    friendly: 'Production Figures',
    validations: {
      maxLength: 45,
    },
  },
  c_msrp: {
    friendly: 'MSRP',
    validations: {
      type: 'decimal',
    },
    typeHint: typeHints.Monetary,
  },
  c_engine_manufacturer: {
    friendly: 'Engine Manufacturer',
    validations: {
      maxLength: 45,
    },
  },
  c_cylinders: {
    friendly: 'Cylinders',
    validations: {
      maxLength: 45,
    },
  },
  c_capacity: {
    friendly: 'Capacity',
    validations: {
      maxLength: 45,
    },
  },
  c_engine_location: {
    friendly: 'Engine Location',
    validations: {
      maxLength: 45,
    },
  },
  c_displacement: {
    friendly: 'Displacement',
    validations: {
      maxLength: 45,
    },
  },
  c_max_power: {
    friendly: 'Max Power',
    validations: {
      maxLength: 45,
    },
  },
  c_max_torque: {
    friendly: 'Max Torque',
    validations: {
      maxLength: 45,
    },
  },
  c_compression: {
    friendly: 'Compression',
    validations: {
      maxLength: 45,
    },
  },
  c_bore_x_stroke: {
    friendly: 'Bore X Stroke',
    validations: {
      maxLength: 45,
    },
  },
  c_lubrication_system: {
    friendly: 'Lubrication System',
    validations: {
      maxLength: 45,
    },
  },
  c_fuel_system: {
    friendly: 'Fuel System',
    validations: {
      maxLength: 45,
    },
  },
  c_value_per_cylinder: {
    friendly: 'Value Per Cylinder',
    validations: {
      maxLength: 45,
    },
  },
  c_cooling_system: {
    friendly: 'Cooling System',
    validations: {
      maxLength: 45,
    },
  },
  c_transmission: {
    friendly: 'Transmission',
    validations: {
      maxLength: 45,
    },
  },
  c_drive_train: {
    friendly: 'Drive Train',
    validations: {
      maxLength: 45,
    },
  },
  c_wheelbase: {
    friendly: 'Wheelbase',
    validations: {
      maxLength: 45,
    },
  },
  c_length: {
    friendly: 'Length',
    validations: {
      maxLength: 45,
    },
  },
  c_width: {
    friendly: 'Width',
    validations: {
      maxLength: 45,
    },
  },
  c_height: {
    friendly: 'Height',
    validations: {
      maxLength: 45,
    },
  },
  c_ground_clearance: {
    friendly: 'Ground Clearance',
    validations: {
      maxLength: 45,
    },
  },
  c_curb_weight: {
    friendly: 'Curb Weight',
    validations: {
      maxLength: 45,
    },
  },
  c_max_speed: {
    friendly: 'Max Speed',
    validations: {
      maxLength: 45,
    },
  },
  c_0_60_mph: {
    friendly: '0-60 Mph',
    validations: {
      maxLength: 45,
    },
  },
  c_0_100_mph: {
    friendly: '0-100 Mph',
    validations: {
      maxLength: 45,
    },
  },
  c_quarter_mile: {
    friendly: 'Quarter Mile',
    validations: {
      maxLength: 45,
    },
  },
  c_power_weight_ratio: {
    friendly: 'Power Weight Ratio',
    validations: {
      maxLength: 45,
    },
  },
  c_mileage: {
    friendly: 'Mileage',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  c_state: {
    friendly: 'State',
    validations: {
      type: 'enum',
      enumType: CarState,
    },
  },
  c_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: CarCondition,
    },
  },
  c_current_color: {
    friendly: 'Current Color',
    validations: {
      maxLength: 45,
    },
  },
  c_original_color: {
    friendly: 'Original Color',
    validations: {
      maxLength: 45,
    },
  },
  c_interior_color: {
    friendly: 'Interior Color',
    validations: {
      maxLength: 45,
    },
  },
  c_drive: {
    friendly: 'Drive',
    validations: {
      type: 'enum',
      enumType: CarDrive,
    },
  },
  c_chassis_no_vin: {
    friendly: 'Chassis No Vin',
    validations: {
      maxLength: 45,
    },
  },
  c_engine_no: {
    friendly: 'Engine No.',
    validations: {
      maxLength: 45,
    },
  },
  c_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: CarCondition,
    },
  },
};

export default attributes;

export const CarRequiredAttributes = [];

export const CarItemSearchAttributes = ['c_brand', 'c_year', 'c_model', 'c_sub_model', 'c_body_style'];

export const CarDefaultSplitAttribute = 'c_brand';

export const CarOverviewAttributes = ['title', 'c_mileage', 'c_condition', 'rarity', 'market_value', 'inventory_no', 'tags'];

export const CarSpecificationAttributes = [
  'c_brand',
  'c_year',
  'c_model',
  'c_sub_model',
  'c_body_style',
  'c_origin_country',
  'c_series_production',
  'c_production_figures',
  'c_msrp',
  // Engine:
  'c_engine_manufacturer',
  'c_cylinders',
  'c_capacity',
  'c_engine_location',
  'c_displacement',
  'c_max_power',
  'c_max_torque',
  'c_compression',
  'c_bore_x_stroke',
  'c_lubrication_system',
  'c_fuel_system',
  'c_value_per_cylinder',
  'c_cooling_system',
  'c_transmission',
  'c_drive_train',
  // Dimensions:
  'c_wheelbase',
  'c_length',
  'c_width',
  'c_height',
  'c_ground_clearance',
  'c_curb_weight',
  // Performance
  'c_max_speed',
  'c_0_60_mph',
  'c_0_100_mph',
  'c_quarter_mile',
  'c_power_weight_ratio',
];

export const CarPurchaseAttributes = [
  'purchase_date',
  'purchase_price',
  'c_purchase_condition',
  'purchase_contact',
  'purchase_notes',
];

export const CarDetailAttributes = [
  'c_current_color',
  'c_original_color',
  'c_interior_color',
  'c_drive',
  'c_chassis_no_vin',
  'c_engine_no',
  'accessories',
];

export const CarDisplayAttributes = ['c_brand', 'c_year', 'c_model', 'c_origin_country', 'tags'];

export const CarSliderGalleryAttributes = {
  titleKey: 'c_model',
  subtitleKey: 'c_year',
};




// WEBPACK FOOTER //
// ./src/config/carDataAttributes.js